export const works = [
    {
        title: 'FrontEnd Developer - React Developer',
        company: 'Epignosis learning technologies',
        locationDate: 'Nov 2022 - May 2024 , Iraklion Greece',
        Team: 'Full-time'
    },
    {
        title: 'Teacher Assistant',
        company: 'University of Crete, Department of Computer Science',
        locationDate: 'Feb 2021 - Mar 2024, Iraklion Greece',
        Team: 'Part-time'
    },
    {
        title: 'FrontEnd Developer',
        company: 'Conveos',
        locationDate: 'July 2021 - November 2022, Milano Italy',
        Team: 'Full-time'
    },
    {
        title: 'Computer Technician',
        company: 'NET Computer Center',
        locationDate: 'June 2015 - August 2015, Chania Greece',
        Team: 'Full-time'
    }
];
